var map = {
	"./1.1.jpg": 3117,
	"./1.2.jpg": 978,
	"./1.3.jpg": 975,
	"./1.4.jpg": 9012,
	"./1.5.jpg": 7537,
	"./1.6.jpg": 9766
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4331;